import { avatarBackgroundArr, getRandomNumber } from '../config';
import softServe from '../images/soft-serve-logo.png';
import '../styles/ProfileCard.scss';

type ProfileCardProps = {
  card: {
    image: string;
    name: string;
    occupationName: string;
    collection: string;
  };
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
};

const ProfileCard: React.FC<ProfileCardProps> = (props) => {
  const index = getRandomNumber(10);
  let { background, backgroundBlendMode } = avatarBackgroundArr[index];
  if (!props.card.collection) {
    background = 'black';
  }

  return (
    <div className="profile-card">
      <div
        className="profile-card-body"
        onClick={props.onClick}
        style={{ background, backgroundBlendMode }}
      >
        <div className="profile-img-holder">
          <div className="logo-container">
            <img className="soft-serve" alt="SoftServe" src={softServe}></img>
          </div>
          <img
            className="profile-card-image"
            alt="Avatar"
            src={props.card.image}
          ></img>
        </div>
        <div className="bottom-container">
          <p className="profile-card-title">{props.card.name}</p>
          <p className="profile-card-description">
            {props.card.occupationName}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
